import { Component } from '@angular/core';

@Component({
  selector: 'app-textiles',
  templateUrl: './textiles.component.html',
  styleUrl: './textiles.component.scss'
})
export class TextilesComponent {

}
